import React from "react";
import Layout from "layouts";
import SubscriptionsComponent from "./SubscriptionsComponent";

export default function Subscriptions() {
  return (
    <Layout breadCrumb={[{ label: "Subscriptions", to: "#" }]}>
      <SubscriptionsComponent />
    </Layout>
  );
}
